import React from 'react';

import { Typography } from '../../../DesignSystem';
import { TitleWithTotal } from '../TitleWithTotal';

import { CollapsedTitle } from './styles';

export enum ViewTitleVariant {
    Collapsed = 'collapsed',
    Header = 'header',
    Section = 'section',
}

export interface ViewTitleProps {
    title: string;
    total?: number;
    variant?: ViewTitleVariant;
    onAction?(): void;
}

export function ViewTitle({ title, variant = ViewTitleVariant.Header, onAction, total = 0 }: ViewTitleProps) {
    if (variant === ViewTitleVariant.Collapsed) {
        return (
            <CollapsedTitle onClick={onAction}>
                <Typography type="label" size={16} variant="span">
                    {title}
                </Typography>
            </CollapsedTitle>
        );
    }

    if (variant === ViewTitleVariant.Section) {
        return <TitleWithTotal title={title} total={total} />;
    }

    return (
        <Typography type="label" size={18} variant="span">
            {title} {total}
        </Typography>
    );
}
